import { ChartsComponent } from './../../components/charts/charts.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
export class ChartModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    ChartsComponent
  ],
  exports: [
    ChartsComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ChartModule_tsickle_Closure_declarations() {
/** @type {?} */
ChartModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ChartModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
